import WithSidebarLayout from 'Layout/WithSidebar';
import './styles.scss';

const FormSection = ({ sidebar, children }) => (
    <section className="container form-section">
        <WithSidebarLayout Sidebar={sidebar} breakpoint="lg">
            {children}
        </WithSidebarLayout>
    </section>
);

export default FormSection;
